module.exports = __webpack_public_path__ + "4928e87bb61d893ba9477eb3bae9caa3.mp4";